import Icon from '../components/Icon.vue'

Icon.register({
  smog: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 368c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-544c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h544zM144 464c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-128c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h128zM560 464c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-336c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h336zM144 288c-79.5 0-144-64.5-144-144s64.5-144 144-144c41 0 77.8 17.3 104 44.8 26.2-27.5 63-44.8 104-44.8 54.8 0 102 31 126.3 76.1 15-7.5 31.7-12.1 49.7-12.1 61.9 0 112 50.1 112 112s-50.1 112-112 112h-60.1c-22.6 19.7-51.6 32-83.9 32s-61.4-12.3-83.9-32h-156.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/smog.js
// module id = 1906
// module chunks = 0